
export default {
  // 首页轮播图
  BannerList: 'BannerList',
  // 提交申请
  push_record:'push_record',
};